<span class="loader"></span>
<p class="text-[#37445F] pt-6">잠시만 기다려주세요.</p>
